import { FEATURE_FLAGS, type FeatureFlag } from '@/constants/featureFlags';
import { STORAGE_KEYS } from '@/constants/storageKeys';

export type InboxFeatureBannerConfig = {
  dismissStorageKey: string;
  featureFlag: FeatureFlag;
};

export const INBOX_ANNOUNCEMENT_BANNER = {
  dismissStorageKey: STORAGE_KEYS.ANNOUNCEMENT_INBOX_BANNER_DISMISSED,
  featureFlag: FEATURE_FLAGS.INBOX_ANNOUNCEMENT_BANNER,
} as const satisfies InboxFeatureBannerConfig;
